import React, { useState, useEffect, useCallback, useMemo, useRef } from 'react';
import { CCard, CCardBody, CCardHeader, CCol, CRow, CButton, CAccordion, CAccordionItem, CAccordionHeader, CAccordionBody } from '@coreui/react';
import { DataGrid } from '@mui/x-data-grid';
import { Link, useLoaderData } from 'react-router-dom';
import AxiosInstance from 'src/components/Axios';
import { cilPen, cilSearch, cilPlus } from '@coreui/icons';
import CIcon from '@coreui/icons-react';
import { FaBell } from 'react-icons/fa';
import debounce from 'lodash.debounce';
import { useConvertToLocalTime } from 'src/components/store/useConvertToLocalTime';
import AsyncSelect from 'react-select/async';
import PermissionsNoPage, { Permissions } from 'src/components/Permissions';
import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc'

dayjs.extend(utc)
dayjs.extend(timezone)


const page = 1;
const urlApi = '/notifications';
const urlRouter = '/user-notifications';

export async function LoaderUsersNotifications({ params }) {
  let res = await AxiosInstance.get(`${urlApi}?page=${page}`).then((response) => {
    return response;
  });
  return res;
}

const UsersNotifications = ({ user_data }) => {
  // if (!Permissions(user_data, 'Notifications', 'VIEW_NOTIFICATIONS')) {
  //   return <PermissionsNoPage />;
  // }

  const { data } = useLoaderData();
  const [rows, setRows] = useState(data['hydra:member'] || []);
  const [rowCountState, setRowCountState] = useState(data['hydra:totalItems'] || 0);
  const [selectedUser, setSelectedUser] = useState(null);
  const [selectedUserId, setSelectedUserId] = useState(null);
  const abortControllerRef = useRef(null);

  useEffect(() => {
    setRows(data['hydra:member'] || []);
    setRowCountState(data['hydra:totalItems'] || 0);
  }, [data]);

  const getRowsTable = useCallback((p = 1, userIdParam) => {
    const userId = userIdParam !== undefined ? userIdParam : selectedUserId;
    const userQuery = userId ? `&users.id=${encodeURIComponent(userId)}` : '';

    AxiosInstance.get(`${urlApi}?page=${p}${userQuery}`).then((response) => {
      setRows(response.data['hydra:member']);
      setRowCountState(response.data['hydra:totalItems']);
    });
  }, [selectedUserId]);


  // const fetchUserOptions = useCallback(async (inputValue) => {
  //   const query = inputValue.trim();
  //   if (!query || query.length < 3) {
  //     return [];
  //   }

  //   // Запит на /api/user/search?s=<query> (префікс /api додається в AxiosInstance.baseURL)
  //   const response = await AxiosInstance.get(`/user/search?s=${encodeURIComponent(query)}`);
  //   return response.data.map((user) => {
  //     const name = user.firstName ? ` (${user.firstName})` : '';
  //     return {
  //       label: `${user.username}${name}`,
  //       value: user.id,
  //     };
  //   });
  // }, []);

  //перероблений запит пошуку юзера з доданим аборт контролером
  const fetchUserOptions = useCallback(async (inputValue) => {
    const query = inputValue.trim();
    if (!query || query.length < 3) {
      return [];
    }

    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
    }
    abortControllerRef.current = new AbortController();

    try {
      const response = await AxiosInstance.get(`/user/search?s=${encodeURIComponent(query)}`, {
        signal: abortControllerRef.current.signal,
      });

      return response.data.map((user) => {
        const name = user.firstName ? ` (${user.firstName})` : '';
        return {
          label: `${user.username}${name}`,
          value: user.id,
        };
      });
    } catch (error) {
      if (error.name === 'CanceledError' || error.code === 'ERR_CANCELED') {
        return [];
      }
      throw error;
    }
  }, []);


  const debouncedLoadUserOptions = useMemo(() => debounce((inputValue, resolve, reject) => {
    fetchUserOptions(inputValue)
      .then(resolve)
      .catch(reject);
  },
    300
  ), [fetchUserOptions]);

  useEffect(() => {
    return () => debouncedLoadUserOptions.cancel();
  }, [debouncedLoadUserOptions]);

  const loadUserOptions = useCallback((inputValue) => {
    return new Promise((resolve, reject) => debouncedLoadUserOptions(inputValue, resolve, reject));
  }, [debouncedLoadUserOptions]);

  const handleUserChange = (option) => {
    const userId = option ? option.value : null;
    setSelectedUser(option);
    setSelectedUserId(userId);
    getRowsTable(1, userId);
  };

  const handlePageChange = (page) => {
    getRowsTable(page + 1);
  };

  const handleClearFilters = () => {
    setSelectedUser(null);
    setSelectedUserId(null);
    getRowsTable(1, null);
  };


  const columns = [
    { field: 'id', headerName: 'ID', width: 100 },
    {
      field: 'username', headerName: 'username', width: 200,
      renderCell: (params) => {
        return <Link to={`${urlRouter}/view/${params.row.users.id}`} style={{ textDecoration: "none", color: "rgba(0, 0, 0, 0.87)" }}>{params.row.users.username}</Link>;
      }
    },
    {
      field: 'firstName', headerName: 'Ім\'я', width: 250,

      renderCell: (params) => {
        return <Link to={`${urlRouter}/view/${params.row.users.id}`} style={{ textDecoration: "none", color: "rgba(0, 0, 0, 0.87)" }}>{params.row.users.firstName}</Link>;
      }
    },

    { field: 'title', headerName: 'Назва', width: 250 },
    { field: 'status', headerName: 'Статус', width: 120 },
    {
      field: 'dateEntered', headerName: 'Дата створення', width: 200,
      renderCell: (params) => {
        // return <span>{useConvertToLocalTime(params.row.dateEntered)}</span>;
        return <span> {dayjs(params.row.dateEntered)
          .format('DD.MM.YYYY HH:mm:ss')}</span>
      }
    },
    // { field: 'dateSend', headerName: 'Дата відправки', width: 200 },
    { field: 'error', headerName: 'Помилка', width: 200 },
    {
      field: "action",
      headerName: "Переглянути",
      headerAlign: 'center',
      align: 'center',
      sortable: false,
      width: 110,
      renderCell: (params) => {
        return (
          <Link
            to={`${urlRouter}/view/${params.row.id}`}
            className='cutom-view-icon '
          >
            <CIcon icon={cilSearch} customClassName="nav-icon" height={18} />
          </Link>
        );
      }
    },
  ];

  return (
    <CRow>
      <CCol xs={12}>
        <div className="d-flex justify-content-start mb-3">
          <Link to="/user-notifications/create">
            <CButton color="secondary" title="Створити одиничне сповіщення">
              <CIcon icon={cilPlus} customClassName="nav-icon" height={15} /> Створити сповіщення
            </CButton>
          </Link>
        </div>
        <CCard className="mb-4">
          <CAccordion flush>
            <CAccordionItem>
              <CAccordionHeader><strong>Фільтр</strong></CAccordionHeader>
              <CAccordionBody>
                <CRow className="my-3 mx-2">
                  <CCol md={8}>
                    <AsyncSelect
                      cacheOptions
                      defaultOptions={false}
                      loadOptions={loadUserOptions}
                      value={selectedUser}
                      onChange={handleUserChange}
                      isClearable
                      placeholder="Пошук користувача"
                    />
                  </CCol>
                  <CCol md={4}>
                    <CButton color="secondary" variant="outline" onClick={handleClearFilters}>
                      Очистити фільтри
                    </CButton>
                  </CCol>
                </CRow>
              </CAccordionBody>
            </CAccordionItem>
          </CAccordion>
          <CCardHeader>
            <strong><FaBell className="nav-icon" /> Сповіщення користувачів</strong> <small></small>
          </CCardHeader>
          <CCardBody>
            {/* <p className="text-medium-emphasis small">
              <Link to={`${urlRouter}/create`}><CButton color="secondary"><CIcon icon={cilPlus} customClassName="nav-icon" height={15} />Створити</CButton></Link>
            </p> */}
            <div style={{ height: 600, width: '100%' }}>
              <DataGrid
                rows={rows}
                columns={columns}
                pageSize={30}
                rowsPerPageOptions={[30]}
                pagination
                rowCount={rowCountState}
                paginationMode="server"
                onPageChange={handlePageChange}
              />
            </div>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  );
};

export default UsersNotifications;